import React, { FC } from 'react';
import { Product, SelectedProductsState, Feature, Modals, PlanCardsMetadata } from '~/types/products';
import { Preamp } from '@red-digital/bricks';
import { Buttons } from '../../types/preamp';
import Carousel from '~/components/Carousel';
import PlanCard from '../PlanCard/default';
import useWindowSize from '~/hooks/useWindowSize';

interface Props {
  metadata?: PlanCardsMetadata;
  activeProducts: Product[];
  addPhoneState: boolean;
  bundleCost: number;
  bundleFeatures: Feature[];
  carousel: {
    direction: number;
    productIndex: number;
    paginate: (index: number) => void;
  };
  sweetener: {
    label: string;
    value: string;
  };
  singleProduct: boolean;
  isCopper: boolean;
  is500: boolean;
  is1Gig: boolean;
  is2Gig: boolean;
  is5Gig: boolean;
  is7Gig: boolean;
  is200: boolean;
  handleSelectPlan?: (plan: Product) => void;
  setActiveModal: (key: Modals) => void;
  setEeroModal: (product: Product) => void;
  setBroadbandConsumerLabelModal: (product: Product) => void;
  selectedState?: SelectedProductsState;
  isCopper2Fiber: boolean;
  buttons?: Buttons;
  landingPageProduct?: string;
  showPlanCardBanner: boolean;
}

const DefaultPlanCards: FC<Props> = ({
  activeProducts,
  addPhoneState,
  bundleCost,
  bundleFeatures,
  carousel,
  singleProduct,
  sweetener,
  setActiveModal,
  setEeroModal,
  setBroadbandConsumerLabelModal,
  isCopper,
  is200,
  is500,
  is1Gig,
  is2Gig,
  is5Gig,
  is7Gig,
  isCopper2Fiber,
  buttons,
  handleSelectPlan,
  selectedState,
  landingPageProduct,
  showPlanCardBanner,
}) => {
  const { productIndex, paginate, direction } = carousel;
  const { desktop } = useWindowSize();

  const orderProducts = () => {
    activeProducts.sort((x, y) => {
      const xSpeed = x?.dataspeed?.downloadInMbps;
      const ySpeed = y?.dataspeed?.downloadInMbps;
      // Pre-selected product from landing page always takes precedence
      if (x?.productId === landingPageProduct) return -1;
      if (xSpeed < ySpeed) return -1;
      if (xSpeed > ySpeed) return 1;
      return 0;
    });
  };
  orderProducts();

  return (
    <Preamp placement="4xPj6N8UVVzt18dXyTpo8j">
      {(metadata) => (
        <div className="plan-packages__cards" data-testid="plan-packages-cards">
          {!desktop && activeProducts.length ? (
            <Carousel
              productIndex={productIndex}
              paginate={paginate}
              direction={direction}
              productsLength={activeProducts.length}
            >
              <PlanCard
                metadata={metadata || {}}
                addPhoneState={addPhoneState}
                key={activeProducts[productIndex]?.productId}
                selectedState={selectedState}
                singleProduct={singleProduct}
                sweetener={sweetener}
                product={activeProducts[productIndex]}
                setActiveModal={setActiveModal}
                bundleCost={bundleCost}
                bundleFeatures={bundleFeatures}
                setEeroModal={setEeroModal}
                setBroadbandConsumerLabelModal={setBroadbandConsumerLabelModal}
                isCopper={isCopper}
                is500={is500}
                is1Gig={is1Gig}
                is2Gig={is2Gig}
                is5Gig={is5Gig}
                is7Gig={is7Gig}
                is200={is200}
                isCopper2Fiber={isCopper2Fiber}
                buttons={buttons}
                handleSelectPlan={handleSelectPlan}
                showPlanCardBanner={showPlanCardBanner}
              />
            </Carousel>
          ) : (
            activeProducts.map((product) => (
              <PlanCard
                metadata={metadata || {}}
                addPhoneState={addPhoneState}
                key={product?.productId}
                selectedState={selectedState}
                singleProduct={singleProduct}
                sweetener={sweetener}
                product={product}
                setActiveModal={setActiveModal}
                bundleCost={bundleCost}
                bundleFeatures={bundleFeatures}
                setEeroModal={setEeroModal}
                setBroadbandConsumerLabelModal={setBroadbandConsumerLabelModal}
                isCopper={isCopper}
                is500={is500}
                is1Gig={is1Gig}
                is2Gig={is2Gig}
                is5Gig={is5Gig}
                is7Gig={is7Gig}
                is200={is200}
                isCopper2Fiber={isCopper2Fiber}
                buttons={buttons}
                handleSelectPlan={handleSelectPlan}
                showPlanCardBanner={showPlanCardBanner}
              />
            ))
          )}
        </div>
      )}
    </Preamp>
  );
};

DefaultPlanCards.displayName = 'DefaultPlanCards';
export default DefaultPlanCards;
